import React from 'react';
import { Sparkles, Users, Layers, Puzzle } from 'lucide-react';

const philosophyPoints = [
   {
      icon: Sparkles,
      title: 'Reliable & Innovative',
      text: "Solutions built around each client's unique needs and objectives."
   },
   {
      icon: Users,
      title: '20+ Years of Expertise',
      text: 'Two decades of collective knowledge across every project we take on.'
   },
   {
      icon: Layers,
      title: 'Full-Service Capability',
      text: 'Web development, CMS, UI/UX, IT support, testing, and more under one roof.'
   },
   {
      icon: Puzzle,
      title: 'Startup to Enterprise',
      text: 'Customized solutions for startups and Fortune 500 companies alike.'
   },
];

const HomeOurStory = () => {
   return (
      <section className="our-story-banner-area pt-10 pb-10">
         <div className="tw-container-fluid tw-mx-5">
            <div className="our-story-banner">
               <div className='tw-container'>
                  <span className="our-story-banner__badge">Our Story</span>
                  <h2 className="our-story-banner__title">
                     Innovative Insights to Shape Your <span className="our-story-banner__accent">Journey</span>
                  </h2>
                  <div className="tw-flex tw-flex-wrap tw--mx-3">
                     {philosophyPoints.map((point, index) => {
                        const Icon = point.icon;
                        return (
                           <div key={index} className="tw-w-full tw-px-3 sm:tw-w-1/2 lg:tw-w-1/4 tw-mb-6 lg:tw-mb-0">
                              <div className="our-story-banner__card">
                                 <Icon className="our-story-banner__card-icon" size={28} strokeWidth={1.75} aria-hidden="true" />
                                 <h3 className="our-story-banner__card-title">{point.title}</h3>
                                 <p className="our-story-banner__card-text">{point.text}</p>
                              </div>
                           </div>
                        );
                     })}
                  </div>
                  <span className="our-story-banner__arrow" aria-hidden="true">
                     <svg width="85" height="28" viewBox="0 0 85 28" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.5375998,5.1201492 L85,32.1484375 L85,32.1484375 L0,32.1484375 L1.77635684e-15,14.4735116 C1.77635684e-15,8.95066406 4.4771525,4.47351156 10,4.47351156 C11.2085871,4.69259944 12.4071645,4.69259944 13.5375998,5.1201492 Z" fill="currentColor" transform="translate(42.5, 16.0742) scale(1, -1) translate(-42.5, -16.0742)" />
                     </svg>
                  </span>
               </div>
            </div>
         </div>
      </section>
   );
};

export default HomeOurStory;
